import React from 'react';
import { Header } from '../components/Header';
import { Hero } from '../components/Hero';
import { AboutSection } from '../components/AboutSection';
import { ImpactSection } from '../components/ImpactSection';
import { ProgramsSection } from '../components/ProgramsSection';
import { StoriesSection } from '../components/StoriesSection';
import { TrustSection } from '../components/TrustSection';
import { NewsletterSection } from '../components/NewsletterSection';
import { Footer } from '../components/Footer';
import { ScrollToTop } from '../components/ScrollToTop';
export function HomePage() {
  return <div className="font-sans bg-warm-ivory min-h-screen w-full selection:bg-sfrr-pink selection:text-white" data-id="element-661">
      <ScrollToTop data-id="element-662" />
      <Header data-id="element-663" />
      <main data-id="element-664">
        <Hero data-id="element-665" />
        <TrustSection data-id="element-666" />
        <AboutSection data-id="element-667" />
        <ImpactSection data-id="element-668" />
        <ProgramsSection data-id="element-669" />
        <StoriesSection data-id="element-670" />
        <NewsletterSection data-id="element-671" />
      </main>
      <Footer data-id="element-672" />
    </div>;
}